import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.131 17.585a1.12 1.12 0 0 1 0 1.587 1.13 1.13 0 0 1-1.59 0L12 13.606 6.422 19.17a1.13 1.13 0 0 1-1.591 0 1.12 1.12 0 0 1 0-1.587l5.58-5.562L4.83 6.415a1.12 1.12 0 0 1 0-1.586 1.127 1.127 0 0 1 1.592 0L12 10.436l5.579-5.564a1.13 1.13 0 0 1 1.59 0 1.12 1.12 0 0 1 0 1.587l-5.58 5.562z"
    }, null, -1)
  ]))]))
}
export default { render: render }